import { ResponsiveGrid } from '@alifd/next';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import FeedbackList from './components/FeedbackList';

const { Cell } = ResponsiveGrid;

const Feedback = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="意見反應列表"
        breadcrumbs={[
          {
            name: '意見反應',
          },
          {
            name: '意見反應列表',
          },
        ]}
      />
    </Cell>
    <Cell colSpan={12}>
      <FeedbackList />
    </Cell>
  </ResponsiveGrid>
);

export default Feedback;
